import "./App.scss";
import {
  popUpValues,
  axisPopUpValue,
  birthYear,
  pupilaryDistance,
  leftRight
} from "./Constant";
import React, { useState } from "react";
import Glass from "./assets/glass.jpg";
import MicroFrontend from "./MicroFrontend";
import SelectBox from "./components/selectbox";
import Loader from "./components/loader";
import RadioBtn from "./components/RadioBtns/index";

const { REACT_APP_DESKTOP_HOST: reactPHost } = process.env;

function ReactP({ history }) {
  return <MicroFrontend history={history} host={reactPHost} name="reactP" />;
}
function App() {
  const [imageUrl, setImageUrl] = useState(null);
  const [showLoader, setLoader] = useState(null);
  const [selected, setSelected] = useState("one");
  const [loaderText, setLoaderText] = useState("");
  const [selectvalues, setvalues] = useState({
    selectinput1: "0.00",
    selectinput2: "0.00",
    selectinput3: 0,
    selectinput4: "0.00",
    selectinput5: "0.00",
    selectinput6: 0,
    selectinput7: "Select (yyyy)",
    selectinput8: "Select pupillari distance",
    selectinput9: "LEFT",
    selectinput10: "RIGHT"
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setvalues((prevState) => ({ ...prevState, [name]: value }));
  };
  window.getPrescriptionData = (data) => {
    setLoader(false);
    //setImageUrl(img);
    if (data !== null && data !== undefined) {
      const {
        odSph,
        odCyl,
        odAxis,
        osSph,
        osCyl,
        osAxis,
        pdSingle,
        pdLeft,
        pdRight,
        prescriptionType
      } = data;
      if (prescriptionType === "Single Vision" || prescriptionType === "") {
        setSelected("one");
      } else {
        setSelected("two");
      }

      setvalues((prevState) => ({
        ...prevState,
        selectinput1: odSph,
        selectinput2: odCyl,
        selectinput3: odAxis,
        selectinput4: osSph,
        selectinput5: osCyl,
        selectinput6: osAxis,
        selectinput8: pdSingle,
        selectinput9: pdLeft,
        selectinput10: pdRight
      }));
    }
  };
  const {
    selectinput1,
    selectinput2,
    selectinput3,
    selectinput4,
    selectinput5,
    selectinput6,
    selectinput7,
    selectinput8,
    selectinput9,
    selectinput10
  } = selectvalues;

  window.setPreview = (url) => {
    setImageUrl(url);
  };

  window.loaderShowing = ({ value, text }) => {
    setLoader(value);
    setLoaderText(text);
  };

  return (
    <div className="top-container">
      {showLoader && <Loader loadingText={loaderText} />}
      <div className="glass-container">
        <div>
          <img
            src={imageUrl ? imageUrl : Glass}
            className="glass-img"
            alt="preview"
          />
        </div>
      </div>
      <div className="container1">
        <div>
          <ReactP />
        </div>
        <div className="container2">
          <div className="section">
            <div className="Prescription-box" style={{ padding: "15px" }}>
              <h3>PD - Pupillary Distance</h3>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  maxWidth: "350px"
                }}
              >
                <RadioBtn
                  value="one"
                  selected={selected}
                  text="One Number"
                  onChange={setSelected}
                />
                <RadioBtn
                  value="two"
                  selected={selected}
                  text="Two Number"
                  onChange={setSelected}
                />
              </div>
              {selected === "one" ? (
                <SelectBox
                  data={{
                    label: "",
                    optionValues: pupilaryDistance,
                    name: "selectinput8",
                    value: selectinput8,
                    onChange: handleChange,
                    placeholder: "PD"
                  }}
                />
              ) : (
                <div className="left-right-selectbox">
                  <SelectBox
                    data={{
                      label: "",
                      optionValues: leftRight,
                      name: "selectinput9",
                      value: selectinput9,
                      onChange: handleChange,
                      placeholder: "LEFT"
                    }}
                  />
                  <SelectBox
                    data={{
                      label: "",
                      optionValues: leftRight,
                      name: "selectinput10",
                      value: selectinput10,
                      onChange: handleChange,
                      placeholder: "RIGHT"
                    }}
                  />
                </div>
              )}
            </div>
            <div className="sph-cyl-label">
              Select a - or + value for SPH or CYL
            </div>
            <div className="Prescription-box" style={{ padding: "15px" }}>
              <h3>Right Eye-OD</h3>

              <div className="parent-div">
                <div>
                  <SelectBox
                    data={{
                      label: "SPH",
                      optionValues: popUpValues,
                      name: "selectinput1",
                      value: selectinput1,
                      onChange: handleChange
                    }}
                  />
                </div>
                <div>
                  <SelectBox
                    data={{
                      label: "CYL",
                      optionValues: popUpValues,
                      name: "selectinput2",
                      value: selectinput2,
                      onChange: handleChange
                    }}
                  />
                </div>
                <div>
                  <SelectBox
                    data={{
                      label: "Axis",
                      optionValues: axisPopUpValue,
                      name: "selectinput3",
                      value: selectinput3,
                      onChange: handleChange
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="Prescription-box" style={{ padding: "15px" }}>
              <h3>Left Eye-OS</h3>
              <div className="parent-div">
                <div>
                  <SelectBox
                    data={{
                      label: "SPH",
                      optionValues: popUpValues,
                      name: "selectinput4",
                      value: selectinput4,
                      onChange: handleChange
                    }}
                  />
                </div>
                <div>
                  <SelectBox
                    data={{
                      label: "CYL",
                      optionValues: popUpValues,
                      name: "selectinput5",
                      value: selectinput5,
                      onChange: handleChange
                    }}
                  />
                </div>
                <div>
                  <SelectBox
                    data={{
                      label: "Axis",
                      optionValues: axisPopUpValue,
                      name: "selectinput6",
                      value: selectinput6,
                      onChange: handleChange
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="Prescription-box" style={{ padding: "15px" }}>
              <SelectBox
                data={{
                  label: "Birth Year",
                  optionValues: birthYear,
                  name: "selectinput7",
                  value: selectinput7,
                  onChange: handleChange,
                  placeholder: "DOB"
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
